import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import LoadingSpinner from '../../../../../../../../../../../../components/Spinner';
import {
  getAllCompanyEmailTemplates,
  selectCheckboxMap,
  selectDefaultTemplate,
  setDefaultTemplates,
  setStateCodeCheckboxes
} from '../../../../../../../../../../../../redux/modules/emails';
import { getAgentEditPolicyDefaultTemplate } from '../../../../../../../../../../../../redux/modules/emails/defaults';
import {
  selectAgentEmailModalLoading,
  setAgentEmailModalLoading
} from '../../../../../../../../../../../../redux/modules/insured';
import { useCompanyCodes } from '../../../../../../../../../../../../services/company-service';
import { useGetPolicyAgent } from '../../../../../../../../../../../../services/policy-service';

import AgentDetails from './components/AgentDetails';
import EmailForm from './components/EmailForm';

const EmailAgentModal = ({ policy, companyId, insuredId, recordId, jobId }) => {
  const dispatch = useDispatch();
  const defaultTemplate = useSelector(selectDefaultTemplate);
  const modalLoading = useSelector(selectAgentEmailModalLoading);
  const selectedCodes = useSelector(selectCheckboxMap);

  const { data: companyCodes, isLoading: codesLoading } = useCompanyCodes(companyId);
  const { data: policyAgent, isLoading: policyAgentLoading } = useGetPolicyAgent(policy.id, { enabled: !!policy.id });

  useEffect(() => {
    dispatch(getAllCompanyEmailTemplates(companyId));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // set edit policy template after policyAgent is fetched
  useEffect(() => {
    if (!policyAgentLoading) {
      if (policyAgent?.insuranceRequestId) {
        const { agent } = policyAgent;
        const agentName = agent?.first ? agent?.first : agent?.email;
        const policyEditTemplate = getAgentEditPolicyDefaultTemplate(agentName);

        dispatch(setDefaultTemplates(companyId, policyEditTemplate));
        dispatch(setAgentEmailModalLoading(false));
      } else {
        dispatch(setDefaultTemplates(companyId));
        dispatch(setAgentEmailModalLoading(false));
      }
    }
  }, [policyAgentLoading]);

  useEffect(() => {
    if (!Object.keys(selectedCodes).length && !codesLoading) {
      dispatch(setStateCodeCheckboxes(companyCodes));
    }
  }, [companyCodes]);

  if ((!defaultTemplate || modalLoading || policyAgentLoading)) return <LoadingSpinner />;

  return (
    <Box justifyContent="center" mx="auto">
      <AgentDetails policyId={policy.id} />
      <EmailForm insuredId={insuredId} jobId={jobId} policyId={policy.id} recordId={recordId} />
    </Box>
  );
};

EmailAgentModal.propTypes = {
  policy: PropTypes.shape({ ownerId: PropTypes.string }.isRequired),
  companyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  insuredId: PropTypes.number.isRequired,
  jobId: PropTypes.number.isRequired,
  recordId: PropTypes.number.isRequired
};

export default EmailAgentModal;
